// Canvas constants extracted from GameCanvas.js

export const resourceIconMap = {
  iron: "steel",
  gold: "bronze",
};

export const buildIconMap = {
  tower: "/fort.png",
  fort: "/fort.png",
  town: "/town.png",
  farm: "/farm.png",
  mine: "/mine.png",
  stable: "/stable.png",
  "lumber mill": "/lumber_mill.png",
  workshop: "/workshop.png",
};

export const CAPTURE_EFFECT_DURATION_MS = 1600;
export const CAPTURE_EFFECT_MAX = 36;
export const TOUCH_LONG_PRESS_MS = 320;
export const TOUCH_LONG_PRESS_MOVE_PX = 10;

export const ARROW_STATUS_COLORS = {
  advancing: 0x44cc44,
  consolidating: 0xcccc44,
  stalled: 0xcc8844,
  retreating: 0xcc4444,
};

export const ARROW_STATUS_HEX = {
  advancing: "#44cc44",
  consolidating: "#cccc44",
  stalled: "#cc8844",
  retreating: "#cc4444",
};

export const COMBAT_FLASH_DURATION = 800;
